import type { RouteRecordRaw } from "vue-router";

export const pRoutes: RouteRecordRaw[] = [
  {
    path: "/p/logged_out",
    name: "pupil-logout-success",
    component: () => import("./logged_out.vue"),
  },
  // Parent layout route for :id - children get schoolClass prop via RouterView
  {
    path: "/p/school_classes/:id",
    name: "pupil-school-class-show",
    component: () => import("./school_classes/PupilSchoolClassLayout.vue"),
    meta: {
      requiresAuth: true,
      requiresPupil: true,
    },
    children: [
      {
        path: "archived",
        name: "pupil-school-class-archived",
        component: () =>
          import("./school_classes/[id]/archived/PupilSchoolClassArchivedPage.vue"),
        meta: {
          requiresAuth: true,
          requiresPupil: true,
        },
      },
      {
        path: "projects",
        name: "pupil-school-class-projects",
        component: () =>
          import("./school_classes/[id]/projects/PupilSchoolClassProjectListPage.vue"),
        meta: {
          requiresAuth: true,
          requiresPupil: true,
        },
      },
      {
        path: "paused",
        name: "pupil-school-class-paused",
        component: () =>
          import("./school_classes/[id]/paused/PupilSchoolClassPausedPage.vue"),
        meta: {
          requiresAuth: true,
          requiresPupil: true,
        },
      },
      {
        path: "projects/:projectId",
        name: "pupil-school-class-project-show",
        component: () =>
          import("./school_classes/[id]/projects/PupilSchoolClassProjectPage.vue"),
        meta: {
          requiresAuth: true,
          requiresPupil: true,
        },
      },
      {
        path: "projects/:projectId/share",
        name: "pupil-school-class-project-share",
        component: () =>
          import("./school_classes/[id]/projects/[projectId]/share.vue"),
        meta: {
          requiresAuth: true,
          requiresPupil: true,
        },
      },
    ],
  },
];
